import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "options" }
const _hoisted_2 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Popover = _resolveComponent("Popover")

  return (_openBlock(), _createBlock(_component_Popover, {
    modelValue: $data.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.visible) = $event)),
    class: "tracker-select",
    "show-arrow": false,
    placement: "bottom-end",
    teleported: false,
    offset: 2,
    "popper-class": "tracker-popover",
    onShow: _cache[2] || (_cache[2] = $event => ($data.visible = true)),
    onHide: _cache[3] || (_cache[3] = $event => ($data.visible = false))
  }, {
    reference: _withCtx(() => [
      _createElementVNode("div", {
        class: "reference",
        onClick: _cache[0] || (_cache[0] = $event => ($data.visible = true))
      }, [
        _renderSlot(_ctx.$slots, "default", { visible: $data.visible }, undefined, true)
      ])
    ]),
    default: _withCtx(({hide}) => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (opt, idx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: idx,
            disabled: opt.disabled,
            class: "select pointer",
            onClick: $event => ($options.onOptionClick(hide, opt.onClick))
          }, [
            _createVNode(_component_Icon, {
              icon: opt.icon,
              size: "1.6rem",
              stroke: "var(--brand-50)",
              "stroke-width": "1"
            }, null, 8 /* PROPS */, ["icon"]),
            _createTextVNode(" " + _toDisplayString(opt.title), 1 /* TEXT */)
          ], 8 /* PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["modelValue"]))
}